import React, { memo, useState } from "react";
import { Grid, TextField, MenuItem, Select, Button, FormControlLabel, RadioGroup, Radio, Checkbox, FormLabel, FormGroup, Box, Tooltip } from "@mui/material";
import { useSelector } from "react-redux";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { formatOrdinal, weekformat } from "../../../../../utils/helpers/timeZoneConvert";
import SearchField from "./CustomSearchField";
// Deep Search feature disabled for now
// import { setForm1Options } from "../../../../../services/slices/addformSlice";
// import CustomModal from "../../../../../components/common/modal/customModal";

const FilterForm = ({
    title,            // Title displayed on the accordion summary.
    formData,         // Object containing the current form data.
    handleChange,     // Function to handle form field changes.
    fieldsConfig,     // Configuration for the fields inside the accordion.
    errorMessage,     // Object containing validation error messages for fields.
    handleKeyDown,
    handleSearch,
    addnewpopup,
    insideSplit,
    addBtn,
    addAction,
    handleSearchable,
    onClickButton,
    onDelete,
    labelwid
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [pickerValue, setPickerValue] = useState(null);
    const [timeVal, setTimeVal] = useState("");
    const handleFieldClick = () => {
        setIsOpen(true);
    };
    const handleInputChange = (event, field) => {
        const { value } = event.target;
        // Check if the input matches the time format (HH:mm) using a regular expression
        const isValidTimeFormat = /^([01]\d|2[0-3]):([0-5]\d)$/.test(value);
        if (isValidTimeFormat || value === "") {
            // Only update the input value if it's a valid time format or an empty string
            setTimeVal(value);
        }
    };
    const handlePickerClose = () => {
        setIsOpen(false);
        setPickerValue(null)
    }; const shop = useSelector((state) => state.addShop);
    const form3Details = shop?.form3Options;
    // Deep Search feature disabled for now
    // const form1Details = shop?.form1Options;
    // const dispatch = useDispatch();
    // const [deepSearchModalOpen, setDeepSearchModalOpen] = useState(false);
    // const handleDeepsearchChange = (e) => {
    //     if (e.target.checked) {
    //         setDeepSearchModalOpen(true);
    //     } else {
    //         dispatch(setForm1Options({
    //             ...form1Details,
    //             isDeepsearch: ["No"]
    //         }));
    //     }
    // };
    // const confirmDeepSearch = () => {
    //     dispatch(setForm1Options({
    //         ...form1Details,
    //         isDeepsearch: ["Yes"]
    //     }));
    //     setDeepSearchModalOpen(false);
    // };
    // const cancelDeepSearch = () => {
    //     setDeepSearchModalOpen(false);
    // };
    return (
        <div>
            {/* Display accordion title */}
            <Grid container columns={{ xs: 12, sm: 12, md: 12 }} >
                {/* Iterate over fieldsConfig to render fields dynamically */}
                {fieldsConfig.map(
                    (data) => {
                        const { id, label, name, type, placeholder, max, options, optionLength, inputmode, pressKey, pressDot, required, search, disabled, ClassNames, searchPlaceholder, searchable, fullGrid, isButton, col, minDate, maxDate, helperText, helperClassName } = data
                        return (
                            // {/* Render label if applicable */ } 
                            <>
                                {((label && label !== "Infants") && (label && label !== "LOS")) ? (
                                    <Grid item xs={!!labelwid ? 5 : !!insideSplit ? 6 : 4}>
                                        <div className="label-with-search">
                                            <FormLabel htmlFor={id}>
                                                {label === "Adults" || label === "Infants" ? "PAX" : label}
                                                {required ? <span className="sup-text err-txt">*</span> : ""}
                                            </FormLabel>
                                            {search && <Button onClick={(e) => handleSearch(e, name)} className="search-btn-gds">Search</Button>}
                                        </div>
                                        <span className="err-txt">{errorMessage?.[name] || ""}</span>
                                    </Grid>
                                ) : ""}

                                <Grid item xs={(!!labelwid && col) ? 4 : !!labelwid ? 7 : !!fullGrid ? 12 : !!insideSplit ? 4 : (label === "Infants" || label === "Adults") ? 3 : (formData.route === "RT" && label === "Route Type") ? 1 : label === "LOS" ? 4 : 8} key={id} className={`${ClassNames} ${label !== "LOS" ? "mb-15" : ""}`}>
                                    {/* Render based on the field type */}
                                    {(label === "Adults" || label === "Infants" || label === "LOS") ? <div className="label-with-search">
                                        <FormLabel htmlFor={id}>
                                            {label}
                                            {required ? <span className="sup-text err-txt">*</span> : ""}
                                        </FormLabel>
                                        {search && <Button onClick={(e) => handleSearch(e, name)} className="search-btn-gds">Search</Button>}
                                    </div> : ""}
                                    {type === "select" ? (
                                        <Grid container columns={{ xs: 12, sm: 12, md: 12 }} >
                                            <Grid item xs={(!!labelwid && name === "monthDays") ? 5 : 12}>
                                                <Select
                                                    className="input-select"
                                                    fullWidth
                                                    id={id}
                                                    name={name}
                                                    value={formData?.[name] || ""}
                                                    onChange={handleChange}
                                                    disabled={disabled}
                                                    margin="normal"
                                                    displayEmpty
                                                    inputProps={{ "aria-label": "Without label" }}
                                                    MenuProps={{
                                                        anchorOrigin: {
                                                            vertical: "bottom",
                                                            horizontal: "left",
                                                        },
                                                        transformOrigin: {
                                                            vertical: "top",
                                                            horizontal: "left",
                                                        },
                                                    }}
                                                >
                                                    {options.map(({ label, value }, index) => (
                                                        <MenuItem key={index} value={value}>
                                                            {label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </Grid>
                                            {isButton ? <Grid item xs={2}><button onClick={(e) => onClickButton(e, name)} className="add-button">Add</button></Grid> : ""}
                                            {(isButton && (form3Details?.customAdd.length || form3Details?.monthDaysAdd.length)) ? <Grid item xs={12}>
                                                <ol className="days-selection mt-5 mb-5">
                                                    {isButton && name === "monthDays" && form3Details?.customAdd.length
                                                        ? form3Details?.customAdd?.map((customData, indx) => {
                                                            const week = customData && typeof (customData) === "string" && customData?.includes("/")

                                                            if (week) {
                                                                return <li>{indx + 1}.{weekformat(customData)}<button type="button" onClick={(e) => onDelete(e, "custom", customData)}>delete</button></li>

                                                            } else {
                                                                return <li>{indx + 1} .{formatOrdinal(customData)} of the month <button type="button" onClick={(e) => onDelete(e, "custom", customData)}>delete</button></li>
                                                            }
                                                        })
                                                        : isButton && name === "monthDays" && form3Details?.monthDaysAdd.length ?
                                                            form3Details?.monthDaysAdd?.map((md, indx) => {
                                                                return <li>{indx + 1} .{formatOrdinal(md)} of the month <button type="button" onClick={(e) => onDelete(e, "monthDays", md)}>delete</button></li>
                                                            }) : ""}

                                                </ol>
                                            </Grid> : ""}
                                        </Grid  >
                                    ) : type === "searchable-select" ? (
                                        <>
                                            <SearchField data={data} labelwid={labelwid} handleChange={handleChange} />
                                        </>
                                    ) : type === "time" ? (
                                        <Grid container columns={{ xs: 12, sm: 12, md: 12 }} className="time-selection" >
                                            <Grid item xs={(!!labelwid && name === "time") ? 5 : 12} className="timedelivery">
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <Box className="time-field">
                                                        <TextField
                                                            name={name}
                                                            type={"text"}
                                                            onChange={(e) => handleInputChange(e)}
                                                            value={timeVal || ""}
                                                            onClick={handleFieldClick}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            inputProps={{
                                                                step: 300,
                                                                style: { textAlign: "left" },
                                                                placeholder: "Select Time",
                                                            }}
                                                        />
                                                        <TimePicker
                                                            open={isOpen}
                                                            format="HH:mm"
                                                            ampm={false}
                                                            className="input-time-picker"
                                                            value={pickerValue}  // Set the picker value
                                                            onChange={(value) => {
                                                                setTimeVal(dayjs(value).format("HH:mm"))
                                                                handleChange({ target: { name, value: dayjs(value).format("HH:mm A") || "" } });
                                                                setPickerValue(value);  // Update the picker value
                                                            }}
                                                            onClose={handlePickerClose}
                                                        />
                                                    </Box>
                                                </LocalizationProvider>
                                            </Grid>
                                            {isButton ? <Grid item xs={2}><button onClick={(e) => {
                                                setTimeVal("");
                                                setPickerValue("");
                                                onClickButton(e, name)
                                            }} className="add-button" disabled={form3Details?.time === ""}>Add</button></Grid> : ""}
                                            {(isButton && form3Details?.deliveryzone?.length) ?
                                                <Grid item xs={12}>
                                                    <ol className="days-selection mt-5 mb-5">
                                                        {isButton && form3Details?.deliveryzone?.length ?
                                                            form3Details?.deliveryzone?.map((data, indx) => {
                                                                return <li>{indx + 1} . {data.startTime} {data?.timeZone}<button onClick={(e) => onDelete(e, "time", data)}>delete</button></li>
                                                            }) : ""}
                                                    </ol>
                                                </Grid>
                                                : ""}
                                        </Grid>
                                    ) : type === "number" || type === "text" ? (
                                        <div>
                                            <TextField
                                                fullWidth
                                                id={id}
                                                name={name}
                                                type={type || "text"}
                                                value={formData[name] === 0 ? 0 : formData[name] || ""}
                                                onChange={(e) => {
                                                    const { value } = e.target;

                                                    // Prevent leading zeros if type is number
                                                    if (type === "number") {
                                                        const sanitizedValue = value === 0 || value === "0" ? 0 : value.replace(/^0+/, '');
                                                            handleChange({ ...e, target: { ...e.target, value: parseInt(sanitizedValue), name } });
                                                    } else {
                                                        handleChange(e);
                                                    }
                                                }} required={required}
                                                onKeyDown={(e) => {
                                                    if (pressKey) {
                                                        handleKeyDown(e, "pressKey");
                                                    } else if (pressDot) {
                                                        handleKeyDown(e, "pressDot");
                                                    }
                                                    if (type === "text" && name === "customDay") {
                                                        const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
                                                        if (!/[\d,]/.test(e.key) && !allowedKeys.includes(e.key)) {
                                                            e.preventDefault();
                                                        }
                                                    }

                                                    // Explicitly block minus key just in case
                                                    if ((e.key === "-" || e.key === ".") && type === "number") {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                disabled={disabled}
                                                margin="normal"
                                                inputMode={inputmode}
                                                inputProps={
                                                    type === "text"
                                                        ? {}
                                                        : { max: max, min: 0, inputMode: 'numeric', pattern: '[0-9]*' }
                                                }
                                                placeholder={placeholder || ""}

                                            />
                                            {helperText ? <p className={helperClassName || "field-helper-text"}>{helperText}</p> : ""}
                                        </div>
                                    ) : type === "checkbox" ? (
                                        <>
                                            {optionLength === 0 ? <span className="no-data-availabe">No {name === "meta" ? "metasources" : name === "ota" ? "OTAs" : name === "brands" ? "Brands" : name === "gds" ? "GDS" : ""} {name === "yourAirline" ? "Data Found" : "available"}</span> :
                                                <>
                                                    {searchable ? <input type="text" placeholder={searchPlaceholder} className="searchinput-box" onChange={(e) => handleSearchable(e, name, options)} /> : ""}
                                                    <FormGroup>
                                                        <>
                                                            {options.length ? options.map(({ label, value, disabled: optionDisabled, disabledTooltip }) => {
                                                                const isItemDisabled = disabled || optionDisabled;
                                                                 const formControl = (
                                                                    <FormControlLabel
                                                                        key={value}
                                                                        style={isItemDisabled && disabledTooltip ? { cursor: "not-allowed" } : {}}
                                                                        control={
                                                                            <Checkbox
                                                                                checked={formData[name]?.includes(value) || false}
                                                                                disabled={isItemDisabled}
                                                                                style={isItemDisabled && disabledTooltip ? { cursor: "not-allowed" } : {}}
                                                                                onChange={(e) => {
                                                                                    handleChange({
                                                                                        target: {
                                                                                            name,
                                                                                            value: e?.target?.checked
                                                                                                ? [...(formData[name] || []), value]
                                                                                                : [...(formData[name] || [])].filter(v => v !== value)
                                                                                        }
                                                                                    })
                                                                                }}
                                                                            />
                                                                        }
                                                                        label={label}
                                                                        disabled={isItemDisabled}
                                                                    />
                                                                );
                                                                return isItemDisabled && disabledTooltip ? (
                                                                    <Tooltip
                                                                        title={disabledTooltip}
                                                                        arrow
                                                                        key={value}
                                                                        placement="top-start"
                                                                        componentsProps={{
                                                                            tooltip: {
                                                                                sx: {
                                                                                    maxWidth: 240,
                                                                                    fontSize: "12px",
                                                                                    fontWeight: 400,
                                                                                    lineHeight: "1.4",
                                                                                    textAlign: "left",
                                                                                }
                                                                            }
                                                                        }}
                                                                    >
                                                                        <span style={{ display: "inline-block", width: "fit-content", cursor: "not-allowed" }}>{formControl}</span>
                                                                    </Tooltip>
                                                                ) : formControl;
                                                            }) : <span className="no-data-availabe">No Other Source Found</span>}
                                                        </>
                                                    </FormGroup>
                                                </>
                                            }

                                        </>

                                    ) : type === "radio" ? (
                                        <>
                                            <FormGroup>
                                                <RadioGroup
                                                    name={name}
                                                    value={formData[name] || ""}
                                                    onChange={handleChange}
                                                >
                                                    {options.map(({ label, value }) => (
                                                        <FormControlLabel
                                                            key={value}
                                                            value={value}
                                                            control={<Radio />}
                                                            label={label}
                                                        />
                                                    ))}
                                                </RadioGroup>
                                            </FormGroup>
                                        </>
                                    ) /* Deep Search UI ("searchType" field) disabled for now:
                                    : type === "searchType" ? (
                                        <>
                                            <FormGroup>
                                                <FormControlLabel
                                                    style={{ cursor: "not-allowed" }}
                                                    control={<Checkbox checked disabled style={{ cursor: "not-allowed" }} inputProps={{ "aria-label": "Basic search type, always enabled" }} />}
                                                    label="Basic"
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={form1Details?.isDeepsearch?.includes("Yes") || false}
                                                            onChange={handleDeepsearchChange}
                                                            inputProps={{ "aria-label": "Toggle Deep Search" }}
                                                        />
                                                    }
                                                    label="Deep Search"
                                                />
                                            </FormGroup>
                                        </>
                                    ) */ : (
                                        <TextField
                                            fullWidth
                                            id={id}
                                            name={name}
                                            type={type || "text"}
                                            value={formData[name] || ""}
                                            onChange={handleChange}
                                            required={required}
                                            onKeyDown={(e) => {
                                                if (pressKey) {
                                                    handleKeyDown(e, "pressKey");
                                                } else if (pressDot) {
                                                    handleKeyDown(e, "pressDot");
                                                }
                                            }}
                                            disabled={disabled}
                                            margin="normal"
                                            inputMode={inputmode}
                                            placeholder={placeholder || ""}
                                            InputProps={{
                                                inputProps: type === 'date' ? { min: minDate, max: maxDate ? maxDate : null } : {}

                                            }}
                                        />
                                    )}
                                </Grid>

                                {(!!insideSplit && !fullGrid) ? <Grid item xs={2} >
                                    {(!!addBtn && name === "endDay") && <button onClick={addAction} className="add-button">Add</button>}
                                </Grid> : ""}
                            </>
                        )
                    }
                )}
            </Grid >
            {/* Deep Search confirmation modal disabled for now
            <CustomModal
                open={deepSearchModalOpen}
                cancellable
                handleClose={cancelDeepSearch}
                handleClickOk={confirmDeepSearch}
                confirmLabel="Yes"
                cancelLabel="No"
                content={[
                    { header: "Deep Search" },
                    { modalContent: "Selecting Deep Search enables the scraping system to extract additional details from the sources (subject to feasibility). As a result, each source requires more request calls, leading to higher call usage." },
                    { modalContentTwo: "Please let us know if you'd like to continue with the selection." }
                ]}
            />
            */}
        </div >
    );
};

// Exporting component using memo for optimization (avoiding unnecessary re-renders).
export default memo(FilterForm);





